import { render, staticRenderFns } from "./IssueTrackerDropdownSelector.vue?vue&type=template&id=056ad32c&scoped=true&"
import script from "./IssueTrackerDropdownSelector.vue?vue&type=script&lang=js&"
export * from "./IssueTrackerDropdownSelector.vue?vue&type=script&lang=js&"
import style0 from "./IssueTrackerDropdownSelector.vue?vue&type=style&index=0&id=056ad32c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ad32c",
  null
  
)

export default component.exports